module.exports = __webpack_public_path__ + "img/skanska_k_letter.f4c6b7e6.jpeg";